import React from 'react';
import '../Colors.css';

const Caution = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 286.46 286.46" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslWarningRed' d="M278.569,215.773c3.425,4.894,4.894,10.766,4.894,16.638c0,16.638-13.703,30.83-30.83,30.83H30.461
        c-10.767,0-21.042-5.872-26.427-15.66c-5.382-9.298-5.382-21.042,0-30.34L115.121,24.432c5.382-9.298,15.659-15.171,26.424-15.171
        c11.256,0,21.042,5.872,26.915,15.171L278.569,215.773z"/>
      <path className='Black' d="M158.671,76.793c0.49-5.872-3.425-10.276-8.808-10.276h-16.638c-5.383,0-8.809,4.404-8.318,10.276
        l8.318,95.916c0.49,4.893,3.916,8.319,8.318,8.319c4.894,0,8.32-3.426,8.809-8.319L158.671,76.793z M158.183,214.305
        c0-9.298-6.852-16.149-16.64-16.149c-9.296,0-16.637,6.852-16.637,16.149v2.447c0,9.298,7.341,16.149,16.637,16.149
        c9.787,0,16.64-6.852,16.64-16.149V214.305z"/>
    </svg>
  );
};

export default Caution;